import "./index-service-hero.css";

export default function ServiceHero({
  eyebrow,
  title,
  description,
  image,
  quote,
}) {
  return (
    <section className="service-hero">
      <div className="service-hero-copy">
        <div className="hero-text">
          <span className="eyebrow">{eyebrow}</span>
          <h1>{title}</h1>
          <p>{description}</p>
          <i />
        </div>
        <div className="hero-photo">
          {image && <img src={image} alt="" />}
          {quote && <span>{quote}</span>}
        </div>
      </div>
    </section>
  );
}